import { TokenUserHelper } from "../services/token-user-service";
import { FunctionComponent } from "react";
import { IVideoLessionProgram } from "../models/videoLessionProgram";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { isSelected } from "../utilities/utils";

interface VideoLessionFilesMenuProps {
    menuCollapsed?: boolean;
    onExpandRequest?: () => void;
}

export const VideoLessionFilesMenu: FunctionComponent<VideoLessionFilesMenuProps> = ({ menuCollapsed = false, onExpandRequest = () => {} }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const tokenUserVideoLessionPrograms = TokenUserHelper.GetVideoLessionPrograms();

    const isAnyProgramSelected = tokenUserVideoLessionPrograms.some(program => {
        const programPath = `/Schools/VideoLessionFiles/${program.filterName}`;
        return isSelected(location.pathname, programPath);
    });

    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        setOpen(isAnyProgramSelected && !menuCollapsed);
    }, [isAnyProgramSelected, menuCollapsed]);

    const handleProgramClick = (program: IVideoLessionProgram) => {
        navigate('/Schools/VideoLessionFiles/' + program.filterName);
    };

    if (tokenUserVideoLessionPrograms.length === 0) return null;

    if (menuCollapsed) {
        return (
            <Tooltip title="Video Lesson Files" placement="right">
                <ListItemButton
                    onClick={onExpandRequest}
                    selected={isAnyProgramSelected}
                    sx={{ justifyContent: 'center', px: 1 }}
                >
                    <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center' }}>
                        <VideoLibraryIcon />
                    </ListItemIcon>
                </ListItemButton>
            </Tooltip>
        );
    }

    return (
        <>
            <ListItemButton onClick={() => setOpen(!open)} selected={isAnyProgramSelected}>
                <ListItemIcon>
                    <VideoLibraryIcon />
                </ListItemIcon>
                <ListItemText primary={'Video Lesson Files'} sx={{ fontSize: '0.875rem' }} disableTypography />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {tokenUserVideoLessionPrograms.map((program, index) => {
                        const programPath = `/Schools/VideoLessionFiles/${program.filterName}`;
                        const selected = isSelected(location.pathname, programPath);
                        return (
                            <ListItemButton
                                key={index}
                                sx={{ pl: 4 }}
                                onClick={() => handleProgramClick(program)}
                                selected={selected}
                            >
                                <ListItemIcon>
                                    <OndemandVideoIcon />
                                </ListItemIcon>
                                <ListItemText primary={program.filterName} disableTypography sx={{ fontSize: '0.875rem' }} />
                            </ListItemButton>
                        );
                    })}
                </List>
            </Collapse>
        </>
    );
};
